import { useContext } from "react";
import { AppContext } from "../AppContext";
import  Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./detail.css";
export default function Project() {
  const { data } = useContext(AppContext);
  var slider=null;
  const settings = {
      dots: true,
      // dots: {'dot-style':String},
      infinite: true,
      autoplay:true,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
  };
  return (
    <div id="detail">
      <img src={`/image/8.png`} className="pageTitle" />
      <div  className="pContent" >
        <div className="line">
          <img src="./image/WX20250903-221513.png"/>
          <span className="title">安普蕾简介</span>
          <span className="detail">安普蕾HEAD SPA，源自韩国的高端头皮护理品牌。以卓越品质与深度疗愈，服务全球高端顾客群体。</span>
        </div>
        <Slider {...settings}
            ref={c => (slider = c)}>
          <div className='planediv'  >
            <img src="/image/企业1.png" className='plane'/>
          </div>
          <div className='planediv'  >
            <img src="/image/企业2.png" className='plane'/>
          </div>
          <div className='planediv'  >
            <img src="/image/企业3.png" className='plane'/>
          </div>
        </Slider>
        <div className="line line1">
          <span className="title">品牌核心</span>
          <span className="detail">产品溯源：精选意大利62年有机世家SOCO的植物配方，安心有效。</span>
          <span className="detail">尖端设备：携手日本百年名企TAKARA，共研专业头浴系统，奢享护理体验。</span>
          <span className="detail">专业传承：韩国“安普蕾终身教育学院”25年来深耕教育，累计输出30万名认证护理师，技术底蕴深厚。</span>
        </div>
        <div className="line line1">
          <span className="title">全球口碑</span>
          <span className="detail">每年为超10万来自韩国、日本、新加坡、迪拜、加拿大及中国香港等地的顾客，提供标本兼治的头皮解决方案。</span>
        </div>
        <div className="line line1">
          <span className="title">哲学体验</span>
          <span className="detail">超越传统护理，在精心营造的静谧场景与专业流程中，融合精准技法与五感疗愈，为您缔造一场解决实际问题的身心焕活之旅。我们不止关注头发健康，更专注于打造极致的体验感。</span>
        </div>
        <div className="line line2">
          <img  src="./image/文案末端logo.jpg"/>

        </div>
      </div>
    </div>
  );
}